import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {JsonService} from "../../../services/core/json.service";
import {authApiResources} from "../auth.constants";

@Injectable({
  providedIn: 'root'
})
export class AuthDataService {
  private baseURL:any;



  constructor(
    private http: HttpClient,
    private jsonService: JsonService,
  ) {
    this.baseURL = authApiResources;
  }

  onLogin(model: any): Observable<any> {
    const endPoint = `${this.baseURL.login}`;
    return this.http.post<any>(endPoint, model)
                    .pipe(tap((data:any) => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  updateFcmToken(fcmToken: string): Observable<any> {
    return this.http.post<any>(this.baseURL.updateFcmToken, { fcm_token: fcmToken })
      .pipe(catchError(this.errorHandlerMessage));
  }

  onLogout(model: any): Observable<any> {
    const endPoint = `${this.baseURL.logout}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap((data:any) => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }


  onForgotPassword(model: any): Observable<any> {
    const endPoint = `${this.baseURL.forgotPassword}`;
    return this.http.post<any>(endPoint, model)
    .pipe(tap((data:any) => (this.jsonService.doStringify(data))),
    catchError(this.errorHandlerMessage));
  }

  onResetPassword(model: any): Observable<any> {
    const endPoint = `${this.baseURL.resetPassword}`;
    return this.http.post<any>(endPoint, model)
    .pipe(tap((data:any) => (this.jsonService.doStringify(data))),
    catchError(this.errorHandlerMessage));
  }

  // get User Permissions
  getUserPermissions(): Observable<any> {
      const endPoint = `${this.baseURL.userPermissions}`;
     return this.http.get<any>(endPoint).pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage),
      );
    }

  getAuthUserDetail(): Observable<any> {
    const endPoint = `${this.baseURL.userUserDetail}`;
    return this.http.get<any>(endPoint).pipe(
      tap(data => this.jsonService.doStringify(data.data)),
      catchError(this.errorHandlerMessage),
    );
  }

  setAuthUserOfficeSetting(model: any): Observable<any> {
    const endPoint = `${this.baseURL.userOfficeSetting}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap((data:any) => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }


  onImpersonateLogin(token: string): Observable<any> {
    const endPoint = `${this.baseURL.impersonateLogin}`;
    return this.http.post<any>(endPoint, { token })
      .pipe(
        tap((data: any) => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  verify2faLogin(payload: { user_id: number; code: string; device_token?: string }): Observable<any> {
    const endPoint = `${this.baseURL.verify2faLogin}`;
    return this.http.post<any>(endPoint, payload)
      .pipe(tap((data: any) => this.jsonService.doStringify(data)), catchError(this.errorHandlerMessage));
  }

  enable2fa(): Observable<any> {
    const endPoint = `${this.baseURL.enable2fa}`;
    return this.http.post<any>(endPoint, {})
      .pipe(tap((data: any) => this.jsonService.doStringify(data)), catchError(this.errorHandlerMessage));
  }

  verify2fa(code: string): Observable<any> {
    const endPoint = `${this.baseURL.verify2fa}`;
    return this.http.post<any>(endPoint, { code })
      .pipe(tap((data: any) => this.jsonService.doStringify(data)), catchError(this.errorHandlerMessage));
  }

  disable2fa(code: string): Observable<any> {
    const endPoint = `${this.baseURL.disable2fa}`;
    return this.http.post<any>(endPoint, { code })
      .pipe(tap((data: any) => this.jsonService.doStringify(data)), catchError(this.errorHandlerMessage));
  }

  get2faStatus(): Observable<any> {
    const endPoint = `${this.baseURL.get2faStatus}`;
    return this.http.get<any>(endPoint)
      .pipe(tap((data: any) => this.jsonService.doStringify(data)), catchError(this.errorHandlerMessage));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
